import React from 'react';

interface SelectionListProps<T> {
  onChange: (val: T) => void;
  value: T;
  options: {
    name: string;
    value: T;
  }[];
}

export default function SelectionList<T extends string | number | boolean>({
  options,
  value,
  onChange,
}: SelectionListProps<T>) {
  return (
    <div className="selection-list">
      { options.map(({ name, value: aValue }) =>
        <div key={name} className="selection-list-option">
          <label>
            <input
              type="radio"
              onChange={ev => {
                if (ev.target.checked) {
                  onChange(aValue)
                }
              }}
              checked={value === aValue}
            />
            <span>{ name }</span>
          </label>
        </div>
      ) }
    </div>
  );
}
